// extracted by mini-css-extract-plugin
module.exports = {"order":"CatalogOrder_order__3qmtS","customSelect":"CatalogOrder_customSelect__1Qq_U","list":"CatalogOrder_list__29cMJ"};